import * as React from 'react';
import {StyleSheet} from 'react-native';

import {
  DrawerContentComponentProps,
  DrawerContentScrollView,
} from '@react-navigation/drawer';
import {Drawer, useTheme} from 'react-native-paper';
import {
  checkServiceValid,
  getShopServiceAddress,
} from '../../api/exchange';
import {useQuery} from 'react-query';

const DrawerCollapsedItemsData = [
  {
    label: 'Media',
    focusedIcon: 'folder',
    unfocusedIcon: 'folder-outline',
    key: 0,
    screen: 'FilesTab',
  },
  {
    label: 'Chat',
    focusedIcon: 'forum',
    unfocusedIcon: 'forum-outline',
    key: 1,
    screen: 'ContactsTab',
  },
  // {
  //   label: 'Encode\nCompress',
  //   focusedIcon: 'state-machine',
  //   unfocusedIcon: 'state-machine',
  //   key: 2,
  //   screen: 'EncoderTab',
  // },
  {
    label: 'Video\nEditor',
    focusedIcon: 'scissors-cutting',
    unfocusedIcon: 'scissors-cutting',
    key: 2,
    screen: 'EditorTab',
  },
  {
    label: 'Settings',
    focusedIcon: 'cog',
    unfocusedIcon: 'cog-outline',
    key: 3,
    screen: 'SettingsTab',
  },
];

const shop = {
  label: 'Shop',
  focusedIcon: 'cart',
  unfocusedIcon: 'cart-outline',
  key: 5,
  screen: 'ShopTab',
};

function DrawerItems(props: DrawerContentComponentProps) {
  const nav = props.navigation;
  const drawerItemIndex = props.state.index;
  const theme = useTheme();
  const isV3 = true;
  const collapsed = true;

  const drawerItems = useQuery(
    'drawerItems',
    async () => {
      const items: typeof DrawerCollapsedItemsData = JSON.parse(
        JSON.stringify(DrawerCollapsedItemsData),
      );
      try {
        let isKioskEnabled = false;
        try {
          const shopAddress = await getShopServiceAddress();
          isKioskEnabled = await checkServiceValid(shopAddress);
        } catch (err) {
          // console.error(err);
        }
        if (isKioskEnabled) {
          items.push(shop);
        }
      } catch (err) {
        console.error('drawerItems err', err);
      }

      return items;
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchInterval: 15000,
    },
  );
  return (
    <DrawerContentScrollView
      alwaysBounceVertical={false}
      style={[
        styles.drawerContent,
        {
          backgroundColor: theme.colors.surface,
        },
      ]}
      showsVerticalScrollIndicator={false}
      showsHorizontalScrollIndicator={false}>
      {isV3 && collapsed && drawerItems.isFetched && (
        <>
          {(drawerItems.data?.length || 0) > 0 &&
            drawerItems.data?.map((props, index) => (
              <Drawer.Section
                style={styles.collapsedSection}
                key={props.key}>
                <Drawer.CollapsedItem
                  {...props}
                  key={props.key}
                  active={drawerItemIndex === index}
                  onPress={() => {
                    nav.navigate(props.screen);
                  }}
                />
              </Drawer.Section>
            ))}
        </>
      )}
    </DrawerContentScrollView>
  );
}

const styles = StyleSheet.create({
  drawerContent: {
    flex: 1,
  },
  preference: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 12,
    paddingHorizontal: 16,
  },
  v3Preference: {
    height: 56,
    paddingHorizontal: 28,
  },
  badge: {
    alignSelf: 'center',
  },
  collapsedSection: {
    marginTop: 16,
    fontSize: 12,
  },
  annotation: {
    marginHorizontal: 24,
    marginVertical: 6,
  },
});

export default DrawerItems;
